import { apmRegister } from '@king-fisher/ifund-business';

export const registerMultiPageApm = (param) => {
    apmRegister({
        service: `ijijin::fefund-indexValuation-${param}`
    })
}

/**
 * 
 * @param {'js' | 'ajax'} type 
 * @param {string} searchLog 
 * @param {Error} error 
 */
export const reportError = (type, searchLog, error) => {
    ClientMonitor.reportFrameErrors(
        {
            category: type,
            grade: 'Error',
            timeout: 2000
        },
        {
            message: JSON.stringify({
                searchLog,
                errorMessage: error?.message,
            })
        }
    )
}
